import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiLink } from 'react-icons/hi';
import ModalLayout from '../../../layouts/ModalLayout';
import Button from '../../../buttons/Button';

interface AuthParamsModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSubmitted: (auth: AuthParams) => void;
}

interface AuthParams {
  accountName: string;
  userName: string;
  passPhrase: string;
}

export default function AuthParamsModal({
  open,
  setOpen,
  onSubmitted,
}: AuthParamsModalProps): JSX.Element {
  const { t } = useTranslation('', { keyPrefix: 'page.crm' });

  const [authParams, setAuthParams] = useState<AuthParams>({
    accountName: '',
    userName: '',
    passPhrase: '',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setAuthParams((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <ModalLayout
      open={open}
      setOpen={setOpen}
      closeButton
      className="relative z-50 w-[45rem] min-w-[300px] rounded-2xl bg-secondary-50 p-8">
      <div className="mb-6">
        <h2 className="text-xl font-semibold">
          {t('authParams.title')}
        </h2>
        <p className="text-sm text-gray-600">
          {t('authParams.subtitle')}
        </p>
      </div>

      <div className="space-y-4">
        <div key="account-name-div" className="w-full overflow-visible">
          <p className="mb-1 pr-2 font-medium"> {t('authParams.accountName')}*</p>
          <input
            type="text"
            name="accountName"
            value={authParams.accountName}
            onChange={handleInputChange}
          />
        </div>
        <div key="username-div" className="w-full overflow-visible">
          <p className="mb-1 pr-2 font-medium"> {t('authParams.username')}*</p>
          <input
            type="text"
            name="userName"
            value={authParams.userName}
            onChange={handleInputChange}
          />
        </div>
        <div key="pass-phrase-div" className="w-full overflow-visible">
          <p className="mb-1 pr-2 font-medium"> {t('authParams.passPhrase')}*</p>
          <input
            type="password"
            name="passPhrase"
            value={authParams.passPhrase}
            onChange={handleInputChange}
          />
        </div>
      </div>

      <div className="mt-6 flex">
        <Button variant="primary" onClick={() => onSubmitted(authParams)}>
          <HiLink className="inline-block h-5 w-5" />
          {t('connect')}
        </Button>
        <Button onClick={() => setOpen(false)} className="hover:text-opacity-60">
          {t('cancel')}
        </Button>
      </div>
    </ModalLayout>
  );
}
